import { useEffect } from 'react';
import { useAvailableMeasures } from '../../../api/work-periods-client/work-periods-client.hooks';
import { ModuleType } from '../../../api/work-periods-client/work-periods-client.type';
import { useGlobalStore } from '../../../store/global-store/global-store';
import { useProcessAnalysisStore } from '../../../store/process-analysis-store/process-analysis-store';
import { setAvailableMeasures } from '../../../store/process-analysis-store/process-analysis-store.actions';
import { filterDeprecatedMeasures } from '../../../store/process-analysis-store/process-analysis-store.helpers';
import { Tab } from '../process-analysis.type';

/**
 * Custom hook that fetches available measures data
 *
 * @returns {Object} Object containing loading state
 * @returns {boolean} isLoading - Loading state from query
 */
const useAvailableMeasuresData = (): {
  isLoading: boolean;
} => {
  const portfolio = useGlobalStore((state) => state.portfolio);
  const activeTab = useProcessAnalysisStore((state) => state.activeTab);
  const selectedTeam = useProcessAnalysisStore((state) => state.selectedTeams[0]);
  const selectedBoard = useProcessAnalysisStore((state) => state.selectedBoards[0]);

  const getPayload = () => {
    switch (activeTab) {
      case Tab.Portfolios:
        return portfolio?.id ? { portfolio_id: portfolio.id } : null;
      case Tab.Teams:
        return selectedTeam ? { project_id: selectedTeam } : null;
      case Tab.Boards:
        return selectedBoard ? { subproject_id: selectedBoard } : null;
    }
  };

  const payload = getPayload();

  const { data, query } = useAvailableMeasures({
    payload: {
      scope: [ModuleType.ProcessAnalysis],
      ...(payload || {}),
    },
    options: {
      enabled: !!payload,
    },
  });

  useEffect(() => {
    if (data) {
      const measures = data[ModuleType.ProcessAnalysis]?.measures || [];
      const filteredMeasures = measures.filter(filterDeprecatedMeasures);
      setAvailableMeasures(filteredMeasures);
    }
  }, [data]);

  return { isLoading: query.isFetching };
};

export { useAvailableMeasuresData };
